import { Component, OnInit, ViewChild } from "@angular/core";
import { isBs3 } from "ngx-bootstrap/utils";
import { IDropdownSettings } from "ng-multiselect-dropdown";
import * as _ from "lodash";
import * as moment from "moment";
import { ModalDirective } from "ngx-bootstrap/modal";
// import { Module } from 'ag-grid-community';
import { Module, AllCommunityModules } from "@ag-grid-community/all-modules";
import { ConstantService } from "../../services/constant.service";
import { Router } from "@angular/router";
import { ViewRendererComponent } from "../../renderer/view-renderer.component";
import { ApiService } from "../../services/api.service";
import { GrievanceService } from "../../services/grievance.services";
import { EditButtonRendererComponent } from "../../renderer/edit-button-renderer.component";
import { DeleteButtonRendererComponent } from "../../renderer/delete-button-renderer.component";
import { ExportAsService, ExportAsConfig } from "ngx-export-as";
import { ExcelService } from "../../services/export-excel.service";

@Component({
  selector: "app-experience-letter",
  templateUrl: "./experience-letter.component.html",
})
export class ExperienceLetterComponent implements OnInit {
  @ViewChild('deleteDataModal') public deleteDataModal: ModalDirective;
  @ViewChild("deleteBulkComplainModal")
  public deleteBulkComplainModal: ModalDirective;
  @ViewChild("updateComplaintModal")
  public updateComplaintModal: ModalDirective;
  isBs3 = isBs3();
  public gridApi;
  public gridColumnApi;
  public gridOptions;
  public modules: Module[] = AllCommunityModules;
  public context;
  public frameworkComponents;
  public defaultColDef;
  public columnDefs;
  public permission;
  public rowClassRules;
  public rowSelection;
  _ = _;
  moment = moment;
  selectedYear = moment().format("YYYY");
  selectedMonth = moment().format("MMM");

  dropdownList = [];
  selectedUser: any = {};
  dropdownSettings: IDropdownSettings = {};
  filterParams = {
    dateRange: [new Date(), new Date()],
    org_id: "",
  };

  bsRangeValue: Date[];
  paginaton = {
    totalItems: 0,
    currentPage: 1,
    maxSize: 100,
  };

  years = [
    moment().format("YYYY"),
    moment().subtract(1, "years").format("YYYY"),
    moment().subtract(2, "years").format("YYYY"),
    moment().subtract(3, "years").format("YYYY"),
  ];
  months = this.constantService.MONTHS;

  alert = {
    type: "info",
    msg: "",
    timeout: 3000,
  };
  maxDate = new Date();

  exportAsConfig: ExportAsConfig = {
    type: "pdf", // the type you want to download
    elementIdOrContent: "tableToPrint", // the id of html/table element,
    options: {
      // html-docx-js document options

      jsPDF: {
        orientation: "landscape",
      },
      margins: {
        top: "40px",
        bottom: "40px",
        left: "40px",
        right: "40px",
      },
    },
  };

  fields = ['org_name', 'reference_no', 'letter_no', 'client_name', 'client_address', 'employee_name', 'mobile_number', 'designation', 'date_of_birth', 'father_husband_name', 'joining_date', 'job_last_date', 'issue_date'];
  username = "";
  selectedComplaint: any = {};
  selectedData: any = {};
  exportingCsv = false;
  constructor(
    private constantService: ConstantService,
    private apiService: ApiService,
    private grievanceService: GrievanceService,
    public router: Router,
    private exportAsService: ExportAsService,
    private excelService: ExcelService
  ) {
    this.permission = this.constantService.getCookies().PERMISSION;
    let permissionArray = this.permission.split("");
    this.username = this.constantService.getCookies().USERNAME;

    this.context = { componentParent: this };
    this.defaultColDef = {
      sortable: true,
      filter: true,
      resizable: true,
      floatingFilter: true,
      filterParams: { buttons: ["clear"] },
    };

    this.frameworkComponents = {
      viewRenderer: ViewRendererComponent,
      editButtonRenderer: EditButtonRendererComponent,
      deleteButtonRenderer: DeleteButtonRendererComponent,
    };

    this.rowSelection = "multiple";
    this.columnDefs = [];

    _.each(this.fields, (field) => {
      this.columnDefs.push({
        headerName: this.convertLabel(field),
        field: field,
        width: 120,
      });
    });
    this.columnDefs.push(
      {
        headerName: 'Exp Letter', field: 'secret_key',
        cellRenderer: (invNum) => {
          console.log(invNum);
          return `<a href="https://api.foundryconsultancy.in/report/experience_letter.php?id=${invNum.value}" target="_blank" >View</a>`
        }, width: 100, filter: false, resizable: true, sortable: false, cellClass: ['text-center'], pinned: 'right'
      },
    );

    if (_.includes(permissionArray, 'd')) {
      this.columnDefs.push(
        { headerName: 'Delete', field: 'value', cellRenderer: 'deleteButtonRenderer', colId: 'params1', width: 60, filter: false, resizable: true, sortable: false, pinned: 'right', cellClass: ['text-center'] },
      )
    }
  }

  convertLabel(label: string) {
    return label.replace(/_/g, " ").toUpperCase();
  }

  ngOnInit(): void {
    this.fetchOrg();
    this.searchReport();
  }


  organizationList: any = [];
  fetchOrg() {
    this.apiService.getData('organization').then((resp) => {
      this.organizationList = resp;
    })
  }
  records = [];
  paginatedRecord = [];
  searchReport() {
    this.records = [];
    let queryString =
      `el.*, o.name as org_name
FROM experience_letter el
JOIN organization o ON el.org_id = o.srl_no
WHERE DATE(el.issue_date) BETWEEN '${this.filterParams.dateRange[0].toISOString().split("T")[0]}' AND '${this.filterParams.dateRange[1].toISOString().split("T")[0]}'`;
    if (this.filterParams.org_id) {
      queryString += ` AND org_id = '${this.filterParams.org_id}'`;
    }
    console.log(queryString);
    this.apiService.getCustomData(btoa(queryString)).subscribe((data: any) => {
      this.records = data;
    });
  }

  pageChanged(event): void {
    this.paginaton.currentPage = event.page;
    this.paginatedRecord = this.records.slice(
      (this.paginaton.currentPage - 1) * this.paginaton.maxSize,
      this.paginaton.currentPage * this.paginaton.maxSize
    );
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  methodFromParent(userData) {
    this.selectedData = userData;
    console.log(this.selectedData, userData.action);
    if (userData.action === 'delete') {
      this.deleteDataModal.show();
    }



  }
  onItemSelect(e) { }
  onItemDeSelect(e) { }
  onSelectAll(e) { }


  deleteData() {
    this.apiService.deleteDetail('experience_letter', 'srl_no', [this.selectedData.srl_no]).subscribe((resp) => {
      this.searchReport();
      this.alert.msg = "Successfully deleted!."
      this.alert.type = 'danger';
      setTimeout(() => {
        this.deleteDataModal.hide();
        this.alert.msg = '';
      }, 1000)
    })
  }

}
